import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PainPoint } from './components/PainPoint';
import { TheMoment } from './components/TheMoment';
import { TheProblem } from './components/TheProblem';
import { BlazerEffect } from './components/BlazerEffect';
import { StyleGallery } from './components/StyleGallery';
import { TheStore } from './components/TheStore';
import { Benefits } from './components/Benefits';
import { Imagine } from './components/Imagine';
import { NoRisk } from './components/NoRisk';
import { Contact } from './components/Contact';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
export function App() {
  return <div className="min-h-screen bg-cream-50 font-body text-charcoal selection:bg-olive-200 selection:text-olive-900" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainPoint data-id="element-4" />
        <TheMoment data-id="element-5" />
        <TheProblem data-id="element-6" />
        <BlazerEffect data-id="element-7" />
        <StyleGallery data-id="element-8" />
        <TheStore data-id="element-9" />
        <Benefits data-id="element-10" />
        <Imagine data-id="element-11" />
        <NoRisk data-id="element-12" />
        <Contact data-id="element-13" />
        <FAQ data-id="element-14" />
      </main>

      <Footer data-id="element-15" />
      <WhatsAppFloat data-id="element-16" />
    </div>;
}